import {base} from './base';
import {testType} from './testType';
import {header} from './header';
import {time} from "./time";
import {myCourse} from "./myCourse";
import {myLesson} from "./myLesson";
import {myTest} from "./myTest";
import {result} from "./result";
import {scoreView} from "./scoreView";
import {testInfo} from "./testInfo";
import {welcomeView} from "./welcomeView";
import {titleAlert} from "./titleAlert";
import {errorMessage} from "./errorMessage";

export const laosLanguage = {
    ...base,
    ...testType,
    ...header,
    ...time,
    ...myCourse,
    ...myLesson,
    ...myTest,
    ...result,
    ...scoreView,
    ...testInfo,
    ...welcomeView,
    ...titleAlert,
    ...errorMessage,
};
